export default "__VITE_ASSET__Dg41xSFR__"